export const LIVO_POLICY_TYPES = ['AUTO', 'HOME', 'UMBRELLA', 'DWELLING_FIRE_PERSONAL'];

export function isExpiringLivoPolicy(policy: any, policyTypes: string[] | null = null): boolean {
  const types = Array.isArray(policyTypes) ? policyTypes : LIVO_POLICY_TYPES;
  return (
    policy?.days_left_to_expire >= 0 &&
    policy?.days_left_to_expire <= 30 &&
    policy?.policynumber?.policyNumber?.length === 10 &&
    policy?.policyStatus === 'ACTIVE' &&
    types.includes(policy?.policyType)
  );
}

export function isExpiringAS400Policy(policy: any): boolean {
  return (
    policy?.days_left_to_expire >= 0 &&
    policy?.days_left_to_expire <= 30 &&
    policy?.policynumber?.policyNumber?.length === 6
  );
}

export function isExpiringPolicy(policy: any): boolean {
  return isExpiringLivoPolicy(policy) || isExpiringAS400Policy(policy);
}

export function hasOutstandingAmount(policy: any): boolean {
  const amountStillDue = policy?.billingDetails?.[0]?.amountStillDue ?? 0;
  const priorYearBalance = policy?.priorYearBalance?.theAmount ?? 0;
  return amountStillDue + priorYearBalance > 0;
}
